const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Material Invoice Combination',
  description: 'Material Invoice Combination Settings',
  sortOrder: 1,
  name: 'material_update_combination',
  documentKey: 'material_update_combination',
  values: {
    weight: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'kg',
      displayName: 'Weight',
      documentKey: 'weight',
    },
    currency: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'inr',
      displayName: 'Currency',
      documentKey: 'currency',
    },
    volume: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: 'cft',
      displayName: 'Volume',
      documentKey: 'volume',
    },
  },
};
